/* 2026-10-12 build 8 (round 5: badge kind for the drawer line layout) */
/*
 * GPPrice: the ONE pricing module for the storefront. Display only: the Buy 1 Get 2 Free discount function decides what
 * Shopify charges; this module mirrors it and checks the result.
 *
 *  - Scope:     offerScope(product): tag offer:b1g2 -> 'b1g2', offer:readers3 -> 'readers3', else null (plain price, nothing else).
 *               Cart lines come with their scope from /cart?view=gp (templates/cart.gp.liquid).
 *  - Constants: window.GP_OFFER, emitted from theme settings > GP offer (snippets/gp-pricing-assets.liquid). The only
 *               place the ladder numbers live; nothing in this file hardcodes a price.
 *  - Ladders:   b1g2Price(n) and readers3Price(r); n and r are counted SEPARATELY (units, not lines).
 *  - Badges:    priceBadge(was, price), the single rule for every badge (ladders and cart lines). Never an empty pill.
 *  - Guard:     after every cart update, recompute the expected totals per scope and compare with Shopify + the drawer.
 */
(function () {
  if (window.GPPrice) return;
  // ---------- config: the ONE source of truth is snippets/gp-offer-config.liquid (JSON block #gp-offer-config) ----------
  var CFG = {};
  try { var cfgEl = document.getElementById('gp-offer-config'); if (cfgEl) CFG = JSON.parse(cfgEl.textContent) || {}; } catch (e) { CFG = {}; }
  var cents = function (v) { return Math.round(Number(v || 0) * 100); };
  var S = { list: cents(CFG.listPrice), totals: {}, extra: cents(CFG.extraPairPrice), bundle: Number(CFG.bundleQty) || 3 };
  Object.keys(CFG.totals || {}).forEach(function (k) { S.totals[+k] = cents(CFG.totals[k]); });
  var RC = CFG.readers || {};
  var R = { list: cents(RC.listPrice), pair: cents(RC.pairPrice), threePack: cents(RC.threePackTotal), extra: cents(RC.extraPairPrice) };
  var RPAIR = R.pair > 0 ? R.pair : R.list; // readers: price of pair 1 and pair 2
  var FREE_SHIP = Number(CFG.freeShipThresholdCents || 0); // cents, 0 = every order ships free
  var TXT = CFG.text || {};
  var READY = S.list > 0 && S.totals[1] > 0 && S.extra >= 0;
  if (!READY) {
    // No usable ladder config: leave Shopify's server-rendered prices alone and expose an inert API so other snippets never throw.
    var noop = function () {};
    window.GPPrice = { ready: false, config: {}, offer: CFG, b1g2: S, readers: R, offerScope: offerScope, state: { n: 0, r: 0, known: false, cart: null },
      b1g2Price: function () { return { price: null, was: null }; }, readers3Price: function () { return { price: null, was: null }; }, expectedTotal: function () { return 0; },
      totalFor: function () { return 0; }, nextPair: function () { return 0; }, stateOf: function (n) { return n; }, buttonLabel: function () { return ''; }, money: function () { return ''; }, text: {},
      priceBadge: function () { return null; }, helperLine: function () { return ''; }, refresh: noop, paint: noop, guard: noop };
    try { if (/gp_debug/.test(location.search)) console.warn('[GPPrice] offer config missing or invalid; pricing paint disabled', CFG); } catch (e) {}
    return;
  }
  // legacy mirror for anything that still reads window.GP_OFFER (same numbers, same source)
  window.GP_OFFER = { freeShip: FREE_SHIP, b1g2: { tag: 'offer:b1g2', list: S.list, pair: S.totals[1] || 0, threePack: S.totals[S.bundle] || 0, extra: S.extra }, readers3: { tag: 'offer:readers3', list: R.list, pair: RPAIR, threePack: R.threePack, extra: R.extra } };
  var C = window.GP_OFFER;

  function offerScope(tags) {
    tags = tags || [];
    if (tags.indexOf('offer:b1g2') > -1) return 'b1g2';
    if (tags.indexOf('offer:readers3') > -1) return 'readers3';
    return null;
  }

  // ---------- the sunglasses ladder: cart TOTAL for n pairs, straight from the config totals; extras after the bundle ----------
  function totalFor(n) {
    if (!(n > 0)) return 0;
    if (S.totals[n] != null) return S.totals[n];
    var top = S.bundle; while (top > 0 && S.totals[top] == null) top--;
    return (S.totals[top] || 0) + (n - top) * S.extra;
  }
  // what the NEXT pair costs = next tier total - current total (never typed in): 62.30, 16.70, 10, 15, 15 ...
  function nextPair(n) { return Math.max(0, totalFor(n + 1) - totalFor(n)); }
  function stateOf(n) { return n >= S.bundle ? S.bundle : Math.max(0, n); } // 0, 1, 2, 3 (= three or more)

  // the NEXT pair's display price given units of that scope already in the cart
  function b1g2Price(n) { return { price: nextPair(n), was: S.list }; }
  function readers3Price(r) {
    if (r >= 3) return { price: R.extra, was: R.list };
    if (r === 2) return { price: 0, was: R.list };
    return { price: RPAIR, was: RPAIR < R.list ? R.list : null }; // pairs 1 and 2: readers pair price, list struck when it is lower
  }
  function ladderFor(scope, k) { return scope === 'readers3' ? readers3Price(k) : b1g2Price(k); }

  // what Shopify should charge for k units of a scope
  function expectedTotal(scope, k) {
    if (k <= 0) return 0;
    if (scope === 'b1g2') return totalFor(k);
    if (scope === 'readers3') return k <= 2 ? k * RPAIR : R.threePack + (k - 3) * R.extra;
    return 0;
  }

  // ---------- the single badge rule ----------
  function priceBadge(was, price) {
    if (!(was > 0)) return null;
    if (price === 0) return { text: 'FREE', tone: 'green' };
    if (price >= was) return null;
    var pct = Math.round((1 - price / was) * 100);
    if (pct < 1) return null;
    return { text: pct + '% OFF', tone: 'blue' };
  }

  function money(c) { c = Number(c); if (!isFinite(c)) return ''; return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  // all copy comes from the config texts (tokens already resolved there); nothing here types a number
  function pick(list, k) { if (!list) return ''; var v = list[String(k)]; return v == null ? '' : String(v); }
  function helperLine(scope, k) {
    if (scope === 'readers3') return pick(TXT.rline, Math.min(k, 3));
    return pick(TXT.line, stateOf(k));
  }
  function buttonLabel(k) { return pick(TXT.button, stateOf(k)); }
  // ladder badge: sunglasses use the config badge for the state (30% OFF / 2ND PAIR · ADD FOR $17 / ...), readers derive from the numbers
  function ladderBadge(scope, k, was, final) {
    // a pair whose own price is at or below the ladder price (e.g. a product still listed at $30) gets no badge and no strike: nothing is off
    if (was == null || !(final < was)) return null;
    if (scope === 'b1g2') { var t = pick(TXT.badge, stateOf(k)); if (t) return { text: t, tone: final === 0 ? 'green' : 'blue' }; }
    return was == null ? null : priceBadge(was, final);
  }
  // null badge = render nothing at all (no empty pill)
  // Only touch the DOM when the value changes: every paint used to rewrite every text node, which session recorders
  // (Microsoft Clarity) replay as doubled "$62$62" text even though the live page shows it once.
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function paintBadge(el, b) {
    if (!el) return;
    if (!b || !b.text) { if (!el.hidden) { el.hidden = true; setText(el, ''); el.style.setProperty('display', 'none', 'important'); } return; }
    if (el.hidden) { el.hidden = false; el.style.removeProperty('display'); }
    setText(el, b.text);
    el.classList.toggle('gp-ladder__badge--green', b.tone === 'green');
    el.classList.toggle('gp-ladder__badge--blue', b.tone !== 'green');
    el.classList.toggle('gp_free_badge', b.tone === 'green'); // cart drawer green style
  }

  var state = { n: 0, r: 0, known: false, cart: null };
  var frame = 0;

  function paintLadder(el) {
    try { paintLadderInner(el); } catch (e) { if (isDev()) console.error('[GPPrice] paint failed', e); }
  }
  function paintLadderInner(el) {
    var scope = el.getAttribute('data-gp-scope') || 'b1g2';
    // sunglasses (brief 2026-10-12 A3): the price block ALWAYS shows the first-pair view ($69, $89 struck, SAVE $20); only the add button follows the cart
    var k = scope === 'readers3' ? state.r : 0;
    var base = +el.getAttribute('data-gp-base');
    if (!(base > 0)) return; // no product price on the element: leave it as rendered
    var lad = ladderFor(scope, k);
    var final = Math.min(lad.price, base);
    var was = lad.was == null ? null : Math.min(lad.was, base);
    var now = el.querySelector('.gp-ladder__now'), wasEl = el.querySelector('.gp-ladder__was'), help = el.querySelector('.gp-ladder__help');
    setText(now, final === 0 ? 'FREE' : money(final));
    if (wasEl) { var show = was != null && final < was; if (wasEl.hidden !== !show) wasEl.hidden = !show; if (show) setText(wasEl, money(was)); }
    paintBadge(el.querySelector('[data-gp-badge]'), ladderBadge(scope, k, was, final));
    // the help line under the price DOES follow the cart (BUY 1, GET 2 FREE -> YOUR 2ND PAIR IS FREE -> ... -> ADD ANOTHER PAIR · $15)
    var kc = scope === 'readers3' ? state.r : 0; // sunglasses: the line under the price is static (config text.browse)
    setText(help, helperLine(scope, kc));
    var st = kc >= 3 ? '3' : String(kc);
    if (el.getAttribute('data-gp-state') !== st) el.setAttribute('data-gp-state', st);
  }
  // Cart row badge, from the ROW's combined price (one row per variant, qty units). Only a $0 row says FREE.
  //   sunglasses: $0 -> "FREE · BUY 1, GET 2 FREE" · all units at the extra price -> "EXTRA PAIR · $15" ("EXTRA PAIRS · $15 EACH" for several)
  //               otherwise "SAVE $X" + "· k FREE" when the row holds free pairs, or "· 2 FREE PAIRS UNLOCKED" with 3+ pairs in the cart
  //   readers / other lines: FREE at $0, else the computed % badge. n = eligible pairs in the whole cart.
  function lineBadgeFor(scope, base, final, n, qty) {
    qty = qty > 0 ? qty : 1;
    if (!(base > 0)) return null;
    if (final === 0) return { text: 'FREE', tone: 'green', msg: false }; // round 2: just FREE
    if (scope === 'b1g2' && final < base) {
      if (S.extra > 0 && final === S.extra * qty) return { text: 'SAVE ' + money(base - final), tone: 'blue', msg: true }; // v3 review #3: an extra pair shows its saving (list - extra), same tag style as a paid pair
      return { text: 'BUY 1 GET 2 FREE', tone: 'blue', msg: true }; // round 2: one short label, always one line
    }
    var b = priceBadge(base, final);
    return b ? { text: b.text, tone: b.tone, msg: false } : null;
  }
  function paintLineBadges() {
    document.querySelectorAll('[data-gp-line-badge]').forEach(function (el) {
      var row = el.closest('[data-gp-line]'); var scope = row ? row.getAttribute('data-gp-scope') : '';
      var b = lineBadgeFor(scope, +el.getAttribute('data-base'), +el.getAttribute('data-final'), state.n, +el.getAttribute('data-qty') || 1);
      el.classList.toggle('gp-msg', !!(b && b.msg));
      el.setAttribute('data-gp-kind', !b ? '' : b.tone === 'green' ? 'free' : (S.extra > 0 && +el.getAttribute('data-final') === S.extra * (+el.getAttribute('data-qty') || 1) ? 'extra' : 'save'));
      paintBadge(el, b);
    });
  }
  function paintAll() {
    if (frame) return;
    var run = function () {
      frame = 0;
      try { document.querySelectorAll('[data-gp-ladder]').forEach(paintLadder); paintLineBadges(); } catch (e) { if (isDev()) console.error('[GPPrice] paintAll failed', e); }
    };
    frame = document.visibilityState === 'visible' && window.requestAnimationFrame ? requestAnimationFrame(run) : setTimeout(run, 0);
  }

  // ---------- live cart ----------
  var fetching = null;
  function refresh() {
    if (fetching) return fetching;
    fetching = (window.__gpNativeFetch || window.fetch)('/cart?view=gp', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var cart; try { cart = JSON.parse(t); } catch (e) { throw new Error('cart feed not JSON'); }
        if (!cart || !Array.isArray(cart.items)) throw new Error('cart feed shape');
        var n = 0, r = 0;
        cart.items.forEach(function (it) { if (it.scope === 'b1g2') n += it.qty; else if (it.scope === 'readers3') r += it.qty; });
        state.n = n; state.r = r; state.known = true; state.cart = cart;
        paintAll();
        scheduleGuard();
        try { document.dispatchEvent(new CustomEvent('gp:cart', { detail: { n: n, r: r, total: cart.total } })); } catch (e) {}
      })
      .catch(function (e) { if (isDev()) console.error('[GPPrice] cart read failed', e); })
      .then(function () { fetching = null; });
    return fetching;
  }
  var t = 0;
  function refreshSoon() { clearTimeout(t); t = setTimeout(refresh, 250); }

  // ---------- runtime guard ----------
  var guardTimer = 0;
  function scheduleGuard() { clearTimeout(guardTimer); guardTimer = setTimeout(function () { try { guard(); } catch (e) { if (isDev()) console.error('[GPPrice] guard failed', e); } }, 450); }
  // Dev = Shopify's own signals only (never a hand-set flag): theme editor, *.shopifypreview.com share links, or ?gp_debug
  function isDev() {
    var s = window.Shopify || {};
    return s.designMode === true || location.hostname.endsWith('.shopifypreview.com') || new URLSearchParams(location.search).has('gp_debug');
  }
  function parseMoney(txt) { var m = String(txt || '').replace(/,/g, '').match(/-?\d+(\.\d+)?/); return m ? Math.round(parseFloat(m[0]) * 100) : 0; }

  function guard() {
    var cart = state.cart; if (!cart) return;
    var drawer = document.getElementById('shopify-section-cart-drawer');
    var rows = drawer ? drawer.querySelectorAll('[data-gp-line]') : [];
    var n = 0, r = 0, nonOffer = 0, wasSum = 0, offerFinal = 0, failed = [];
    cart.items.forEach(function (it) {
      if (it.both) failed.push('product in both ladders: ' + it.handle);
      if (it.scope === 'b1g2') { n += it.qty; wasSum += S.list * it.qty; offerFinal += it.final; if (it.unit_base !== S.list) failed.push('b1g2 line base ' + it.handle + ' = ' + it.unit_base + ', expected ' + S.list); }
      else if (it.scope === 'readers3') { r += it.qty; wasSum += R.list * it.qty; offerFinal += it.final; if (it.unit_base !== R.list) failed.push('readers3 line base ' + it.handle + ' = ' + it.unit_base + ', expected ' + R.list); }
      else nonOffer += it.base;
    });
    var expected = expectedTotal('b1g2', n) + expectedTotal('readers3', r) + nonOffer;
    if (cart.total !== expected) failed.push('cart.total_price ' + cart.total + ' != expected ' + expected + ' (n=' + n + ', r=' + r + ')');
    var mix = n && r ? 'mixed' : n ? 'b1g2' : r ? 'readers3' : 'none';
    if (drawer && rows.length && rows.length === cart.items.length) {
      var shown = 0;
      rows.forEach(function (row) { var b = row.querySelector('.bold-price'); shown += parseMoney(b && b.textContent); });
      if (shown !== cart.total) failed.push('sum of displayed line prices ' + shown + ' != cart.total_price ' + cart.total);
      var sav = drawer.querySelector('.gp_savings_row .cart_drawer_items_count');
      var shownSav = sav ? Math.abs(parseMoney(sav.textContent)) : 0;
      if (shownSav !== wasSum - offerFinal) failed.push('displayed SAVINGS ' + shownSav + ' != sum(was) - offer lines ' + (wasSum - offerFinal));
      var hdr = drawer.querySelector('[data-gp-header]');
      var hdrVal = hdr ? hdr.getAttribute('data-gp-header') : 'none';
      if (hdrVal !== mix) failed.push('header renders "' + hdrVal + '" but cart scope mix is "' + mix + '"');
      var litS = drawer.querySelectorAll('[data-gp-scope="b1g2"] .gp-step.on').length;
      var litR = drawer.querySelectorAll('[data-gp-scope="readers3"] .gp-step.on').length;
      if (n && litS !== Math.min(n, 3)) failed.push('sunglasses lit steps ' + litS + ' != ' + Math.min(n, 3));
      if (r && litR !== Math.min(r, 3)) failed.push('readers lit steps ' + litR + ' != ' + Math.min(r, 3));
      var ship = drawer.querySelector('.free_shipping_bar .cart_drawer_items_count');
      if (ship) {
        var showsFree = /^\s*FREE\s*$/i.test(ship.textContent);
        // threshold 0 (settings > GP offer) = every order ships free: the row must ALWAYS read FREE
        var mustBeFree = !(FREE_SHIP > 0) || cart.total >= FREE_SHIP;
        if (showsFree !== mustBeFree) failed.push('SHIPPING shows ' + (showsFree ? 'FREE' : 'paid') + ' at total ' + cart.total + (FREE_SHIP > 0 ? ' (threshold ' + FREE_SHIP + ')' : ' (must always be FREE)'));
      }
    }
    // the drawer re-renders with new totals before the cart feed catches up: a mismatch counts only when a fresh read confirms it
    if (failed.length && (state.guardFails = (state.guardFails || 0) + 1) < 2) { setTimeout(refresh, 1500); return; }
    if (!failed.length) state.guardFails = 0;
    var bar = drawer && drawer.querySelector('.gp-guard-bar');
    if (!failed.length) {
      if (drawer) drawer.classList.remove('gp-guard-fallback');
      if (bar) bar.remove();
      window.GPPrice.lastGuard = { ok: true, n: n, r: r, mix: mix, expected: expected, actual: cart.total };
      return;
    }
    window.GPPrice.lastGuard = { ok: false, n: n, r: r, mix: mix, expected: expected, actual: cart.total, failed: failed };
    (isDev() ? console.error : console.warn)('[GPPrice guard] cart does not match the offer ladders', {
      n: n, r: r, expected_total: expected, actual_total: cart.total, failed: failed,
      lines: cart.items.map(function (it) { return { handle: it.handle, scope: it.scope, qty: it.qty, base: it.base, final: it.final }; }),
    });
    if (!drawer) return;
    if (isDev()) {
      if (!bar) { bar = document.createElement('div'); bar.className = 'gp-guard-bar'; var host = drawer.querySelector('.section_holder') || drawer; host.insertBefore(bar, host.firstChild); }
      bar.textContent = 'PRICING GUARD: ' + failed[0] + (failed.length > 1 ? '  (+' + (failed.length - 1) + ' more, see console)' : '');
    } else {
      drawer.classList.add('gp-guard-fallback'); // Shopify's real numbers only: no badges, no struck prices, no savings line
    }
  }

  // ---------- events: any cart mutation, drawer re-render, drawer open/close ----------
  function isCartMutation(url) { return /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url || '')); }
  window.__gpNativeFetch = window.__gpNativeFetch || window.fetch.bind(window);
  var prevFetch = window.fetch;
  window.fetch = function (input) {
    var p = prevFetch.apply(this, arguments);
    try { var url = typeof input === 'string' ? input : (input && (input.url || String(input))); if (isCartMutation(url) && p && p.then) p.then(refreshSoon, function () {}); } catch (e) {}
    return p;
  };
  function hookJq() { if (window.jQuery && !window.__gpPriceJq) { window.__gpPriceJq = true; jQuery(document).ajaxComplete(function (e, x, s) { if (isCartMutation(s && s.url)) refreshSoon(); }); } }
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart-drawer:open', 'cart-drawer:close'].forEach(function (ev) { document.addEventListener(ev, refreshSoon); });
  function hookDrawer() {
    ['open_slider_cart', 'close_slider_cart'].forEach(function (fn) {
      var orig = window[fn];
      if (typeof orig === 'function' && !orig.__gp) { var w = function () { var res = orig.apply(this, arguments); refreshSoon(); return res; }; w.__gp = true; window[fn] = w; }
    });
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var nd = added[j];
        if (nd.nodeType !== 1) continue;
        if (nd.hasAttribute('data-gp-ladder') || nd.hasAttribute('data-gp-line-badge') || (nd.querySelector && nd.querySelector('[data-gp-ladder],[data-gp-line-badge],[data-gp-line]'))) {
          if (state.known) { paintAll(); scheduleGuard(); }
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.GPPrice = { ready: true, config: C, offer: CFG, b1g2: S, readers: R, offerScope: offerScope, b1g2Price: b1g2Price, readers3Price: readers3Price, expectedTotal: expectedTotal,
    totalFor: totalFor, nextPair: nextPair, stateOf: stateOf, buttonLabel: buttonLabel, money: money, text: TXT,
    priceBadge: priceBadge, lineBadgeFor: lineBadgeFor, helperLine: helperLine, refresh: refresh, paint: paintAll, guard: guard, state: state };

  paintLineBadges();
  hookJq();
  document.addEventListener('DOMContentLoaded', function () { hookJq(); hookDrawer(); paintLineBadges(); refresh(); });
  window.addEventListener('load', hookDrawer);
  if (document.readyState !== 'loading') refresh();
})();
